export const items = [
  {
    name: "Nitrile Powder-free Disposable Gloves",
    category: "Gowns/Coveralls",
    description: "Blue non-medical nitrile/vinyl synthetic powder-free disposable gloves to protect against exposure. Available in four different sizes: S, M, L, XL.",
    perbox: "100pcs/box , 1000pcs/case",
    leadTime: "In Stock",
    src: require('../images/gloves.png')
  },
  {
    name: "Non Medical Disposable Face Masks",
    category: "Masks",
    description: "Antibacterial and dustproof trifolded structured daily use face masks with three layers of filter and a flexible metal nose piece to ensure that the mask can fully protect against exposure as well as maintaining a strong permeability.",
    perbox: "50pcs/box , 2000pcs/case",
    leadTime: "In Stock",
    src: require('../images/mask.png')
  },
  {
    name: "KN95 Face Masks",
    category: "Masks",
    description: "FDA certified, antiviral fiber face masks with 5 layers of active carbon high-filtration protection from bacteria and viral infections with a filtration efficiency of 0.3 μm and blocks out more than 95% of particles.  Comes with a flexible metal nose piece to ensure that the mask can fully protect against exposure. ",
    perbox: "50pcs/box , 1000pcs/case",
    leadTime: "In Stock",
    src: require('../images/kn95.png')
  },
  {
    name: "75% Alcohol Hand Sanitizer",
    category: "Hand Sanitizers",
    description: "300mL fragrance and dye free hand sanitizer with a 75% alcohol contect in order to kill 99.99% of germs in three seconds.",
    perbox: "Contact us for detail",
    leadTime: "In Stock",
    src: require('../images/sanitiser.png')
  },
  {
    name: "67% Alcohol Keychain Hand Sanitizer",
    category: "Hand Sanitizers",
    description: "60mL fresh ocean fragrance hand sanitizer with a 66.5% alcohol contect in order to kill 99.99% of germs in three seconds.",
    perbox: "Contact us for detail",
    leadTime: "In Stock",
    src: require('../images/keychain.png')
  },
  {
    name: "Infrared Thermometer",
    category: "Thermometers",
    description: "Thermometer 1",
    perbox: "1pc/box",
    leadTime: "In Stock",
    src: require('../images/thermometer.png')
  },
  {
    name: "Shoe Cover",
    category: "Gowns/Coveralls",
    description: "Gowns/Coverall 1",
    perbox: "100pcs/pack , 2000pcs/case",
    leadTime: "In Stock",
    src: require('../images/shoecover.png')
  },
  {
    name: "Head Cover",
    category: "Gowns/Coveralls",
    description: "Gowns/Coverall 2",
    perbox: "100pcs/pack , 2000pcs/case",
    leadTime: "2-3 weeks",
    src: require('../images/headcover.png')
  },
]

// Mask
// - Non Medical Disposable Face Masks
// - KN95 Face Masks

// Hand Sanitizer
// - 75% Alcohol Hand Sanitizer
// - 67% Keychain Hand Sanitizer

// Thermometer
// - Infrared Thermometer

// Gowns/Coverall
// - Shoe Cover
// - Head Cover